import { calcImageUrl } from '../../util';

import { RhinoImage } from './types';

export function getAssetImageUrl(images: RhinoImage[], options: { height: number; type?: number; width: number }) {
  if (!options.type) {
    return undefined;
  }

  const image = images.find((i) => i.type === options.type);

  if (!image) {
    return undefined;
  }

  return calcImageUrl(image.url, options.height, options.width);
}
